import React from 'react';
import styled from 'styled-components';
import headerIcon from '../../assets/fourthIcon/fouth1.svg';
import icon1 from '../../assets/fourthIcon/image 11.svg';
import icon2 from '../../assets/fourthIcon/image 10.svg';
import icon3 from '../../assets/fourthIcon/image 12.svg';
import icon4 from '../../assets/fourthIcon/image 13.svg';
import icon5 from '../../assets/fourthIcon/image 19.svg';
import icon6 from '../../assets/fourthIcon/image 16.svg';
import icon7 from '../../assets/fourthIcon/image 20.svg';
import icon8 from '../../assets/fourthIcon/Vector.svg';
import icon9 from '../../assets/fourthIcon/image 14.svg';
import icon10 from '../../assets/fourthIcon/image 18.svg';
import icon11 from '../../assets/fourthIcon/image 15.svg';
import icon12 from '../../assets/fourthIcon/image 17.svg';

export default function FourthSection() {
 return (
  <Container id='patnersdiv'>
   <Wrapper>
    <div>
     <Icon src={headerIcon} width='auto' height={'10rem'} />
    </div>
    <div className='header'>
     <Heading>Strategic Partnerships with Cement Plants</Heading>
     <Linebreak>
      <div className='part1'></div>
      <div className='part2'></div>
      <div className='part3'></div>
     </Linebreak>
    </div>
    <p>
     We contribute to making our planet cleaner along with our trusted network
     of co-processing partners
    </p>
    <Icondiv>
     <Icon src={icon1} width='auto' height={'5rem'} />
     <Icon src={icon2} width='auto' height={'5rem'} />
     <Icon src={icon3} width='auto' height={'5rem'} />
     <Icon src={icon4} width='auto' height={'5rem'} />
     <Icon src={icon5} width='auto' height={'5rem'} />
     <Icon src={icon6} width='auto' height={'5rem'} />
     <Icon src={icon7} width='auto' height={'5rem'} />
     <Icon src={icon8} width='auto' height={'5rem'} />
     <Icon src={icon9} width='auto' height={'5rem'} />
     <Icon src={icon10} width='auto' height={'5rem'} />
     <Icon src={icon11} width='auto' height={'5rem'} />
     <Icon src={icon12} width='auto' height={'5rem'} />
    </Icondiv>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #ededed;
`;

const Wrapper = styled.div`
 width: 75%;
 margin: 0 auto;
 padding: 4rem 0;
 text-align: center;
 display: flex;
 flex-direction: column;
 gap: 4rem;
 padding-bottom: 4rem;
 .header {
  width: 70%;
  margin: 0 auto;
 }
 p {
  width: 40%;
  margin: 0 auto;
  font-size: 1.5rem;
 }
`;

const Icon = styled.img`
 width: ${(props) => props.width};
 height: ${(props) => props.height};
 object-fit: cover;
 mix-blend-mode: multiply;
`;

const Heading = styled.h1`
 font-size: 2.5rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #404040;
`;

const Linebreak = styled.div`
 width: 20%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 margin-left: auto;
 margin-right: auto;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.75vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Icondiv = styled.div`
 width: 90%;
 display: flex;
 gap: 2rem;
 flex-wrap: wrap;
 margin: 0 auto;
 justify-content: center;
 align-items: center;
`;
